import apiUseCases from "../api";

export interface UpdateGatewayNameTypes {
  name: string;
  gateway_id: string;
}

export const updateGatewayName = async (dto: UpdateGatewayNameTypes) => {
  const response = await apiUseCases.putUpdateGatewayName(dto);
  return response;
};
